module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination"
  }, [_c('span', {
    staticClass: "page",
    on: {
      "click": _vm.upPage
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('span', {
    staticClass: "page",
    class: [_vm.page.pageNO === 1 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.selectedPageNum(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), (_vm.showOne) ? _c('span', [_vm._v("···")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.page.pageNumArr), function(pageNum) {
    return _c('span', {
      staticClass: "page",
      class: [_vm.page.pageNO === pageNum ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.selectedPageNum(pageNum)
        }
      }
    }, [_vm._v(_vm._s(pageNum))])
  }), _vm._v(" "), (_vm.showTwo) ? _c('span', [_vm._v("···")]) : _vm._e(), _vm._v(" "), (_vm.page.maxNum > 1) ? _c('span', {
    staticClass: "page",
    class: [_vm.page.pageNO === _vm.page.maxNum ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.selectedPageNum(_vm.page.maxNum)
      }
    }
  }, [_vm._v(_vm._s(_vm.page.maxNum))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "page",
    on: {
      "click": _vm.downPage
    }
  }, [_vm._v("下一页")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-b207cdd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/pagination.vue
// module id = 855
// module chunks = 39